/* CookieConsentProvider.js */

import React from 'react';
import CookieConsent from "react-cookie-consent";
import Strings from '../translations/Translations';
import { Track as GA_Track } from '../helpers/GoogleAnalytics';

const cookieName = process.env.REACT_APP_COOKIE_NAME;

export default function CookieConsentProvider() {
  return (
    <CookieConsent
      location='bottom'
      buttonText={Strings('cookie_consent_btn_label')}
      cookieName={cookieName}
      style={{ background: '#2B373B' }}
      buttonStyle={{ color: '#ffffff', fontSize: '1em', background: '#004F6F', padding: '.7em' }}
      expires={150}
      onAccept={() => { GA_Track(); }}
    >
      {Strings('cookie_consent_message')} {' '}
       <a className='text-white' href='https://www.photozig.com/privacy_terms.html' target='_blank' rel='noreferrer noopener'>{Strings('cookie_consent_learn_more')}</a>
    </CookieConsent>
  );
}
